// angular import
import { AfterViewInit, Component, ElementRef, EventEmitter, NgZone, Output, ViewChild } from '@angular/core';
import { NavigationItem } from '../navigation';
import { ThemeConfig } from 'src/app/app-config';
import { DatePipe, Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../../../../shared/common.service';
import { Console } from 'node:console';
import * as CryptoJS from 'crypto-js';
import { ComputationService } from '../../../../../modules/accounts/computation/computation.service';
import { ComputationsService } from '../../../../../modules/computations/computations.service';
@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements AfterViewInit {
  // public method
  // version
  title = 'Demo application for version numbering';
  currentApplicationVersion = environment.appVersion;

  config = ThemeConfig;
  navigation;
  prevDisabled = 'disabled';
  nextDisabled = '';
  contentWidth = 0;
  wrapperWidth: number;
  scrollWidth = 0;
  windowWidth = window.innerWidth;
  dynamicNavData: any; dynamicTooldata; dynamicTooldatacomputation: any
  checkednotes: any; dynamicNavData1: any; ComputationForms: any; checkcomputation: any; ComputationFormschildren: any; computationReport: any; accountsData: any; statusData: any; reportsData: any; computationsData: any
  @Output() NavCollapsedMob = new EventEmitter();
  @ViewChild('navbarContent', { static: false }) navbarContent: ElementRef;
  @ViewChild('navbarWrapper', { static: false }) navbarWrapper: ElementRef;
  notes = []
  DetailedProfit: boolean = false;
  // constructor
  constructor(public nav: NavigationItem, private computationservice: ComputationService, private zone: NgZone, private location: Location, private commonservice: CommonService, private computation: ComputationsService, private datepipe: DatePipe) {
    debugger
    this.dynamicTooldatacomputation = null
    this.navigation = this.nav.get();
    this.accountsData = this.navigation[1].children
    this.statusData = this.navigation[3]
    this.reportsData = this.navigation[4].children
    this.computationsData = this.navigation[2].children
    this.dynamicNavData = this.navigation[1].children[0].children;
    this.dynamicNavData1 = this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children;
    this.ComputationForms = this.navigation[2].children;
    this.ComputationFormschildren = this.navigation[2].children[0].children;
    this.dynamicTooldata = this.navigation[5].children[0].children;
    this.dynamicTooldatacomputation = this.navigation[5].children[0].children[1].children.splice(2, 1);
    this.computationReport = this.navigation[4].children[0].children[0].children
    //this.navigation[5].children[0].children[0].children = this.computationReport.filter(x => x.id != 'iXBRL_Computations_Reports')
    this.navigation[5].children[0].children = this.navigation[5].children[0].children.filter(x => x.id != 'Import')
    var toolsdata = this.navigation[5].children[0].children.splice(2, 1)
    var toolsdata = this.navigation[5].children[0].children.splice(3, 1)
    var userManagement = this.navigation[5].children[0].children.filter(x => x.id == 'user-accounts')
    var FBIrecipts = this.navigation[5].children[0].children.filter(x => x.id == 'FbiReceipt')
    //this.navigation[5].children[0].children.filter(x => x.id != 'Clear Fields')
    if (window.location.pathname == '/business' || window.location.pathname == '/fbireceipt') {
      this.navigation[1].children = null
      this.navigation[3] = []
      this.navigation[4].children = null
      this.navigation[2].children = null
    }
    this.commonservice.Isnavigationdata.subscribe((data) => {
      debugger
      if (data == 2) {
        //this.dynamicNavData1 = this.dynamicNavData1.filter(({ MasterId: id1 }) => this.commonservice.sideMenuNotes.some(({ MasterId: id2 }) => id2 == id1))
        //var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
        if (this.navigation[5].children[0].children.filter(x => x.id == 'Clear Fields')?.length == 0)
          this.navigation[5].children[0].children.push(...toolsdata)
        if (this.navigation[5].children[0].children.filter(x => x.id == 'user-accounts')?.length == 0) {
          this.navigation[5].children[0].children.push(...userManagement)

        }
        if (this.navigation[5].children[0].children.filter(x => x.id == 'FbiReceipt')?.length == 0) {
          this.navigation[5].children[0].children.push(...FBIrecipts)
        }
        if (localStorage.getItem("APPeriodId") != "null" && localStorage.getItem("APPeriodId") != undefined) {
          this.navigation[1].children = this.accountsData
          this.navigation[3] = this.statusData
          this.navigation[4].children = this.reportsData

          this.navigation[2].children = this.computationsData
          this.commonservice.setOpenAccountingPeriod(true)
        }
        else {
          this.navigation[1].children = null
          this.navigation[3] = []
          this.navigation[4].children = null
          this.navigation[2].children = null

        }
        if (this.navigation[1].children != null) {
          this.navigation[1].children[0].children = this.dynamicNavData;
          this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children = null;
          if (this.commonservice.allPagesdata)
            var pagedata = this.commonservice.allPagesdata.filter(x => x.IsDefault == false)
          if (pagedata?.length)
            for (let i = 0; i < pagedata.length; i++) {
              debugger  
              if (pagedata[i].FormName == 'Members Report' ? pagedata[i].FormName = 'Directors Report' : pagedata[i].FormName)
                this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != pagedata[i].FormName.toLowerCase().replaceAll(' ', ''))
            }
          if (this.commonservice.AccountTemplateId == 1 || this.commonservice.AccountTemplateId == 6 || this.commonservice.AccountTemplateId == 7) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "partners_details" && x.id != "incomestatement" && x.id != "directorsreport" && x.id != "statementofcomprehensiveincome")
          }
          else if (this.commonservice.AccountTemplateId == 2 || this.commonservice.AccountTemplateId == 4 || this.commonservice.AccountTemplateId == 8 || this.commonservice.AccountTemplateId == 11) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "partners_details")
          }
          else if (this.commonservice.AccountTemplateId == 3 || this.commonservice.AccountTemplateId == 5) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "partners_details" && x.id != "statementofcomprehensiveincome")
          }
          else if (this.commonservice.AccountTemplateId == 9) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "partners_details" && x.id != "officerscompany" && x.id != "thirdpartyagents" && x.id != "directorsreport" && x.id != "approvalstatus" && x.id != "statementofcomprehensiveincome")
          }
          else if (this.commonservice.AccountTemplateId == 10) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "officerscompany" && x.id != "thirdpartyagents" && x.id != "directorsreport" && x.id != "approvalstatus" && x.id != "statementofcomprehensiveincome")
          }





          const rtRaw = localStorage.getItem('reportType');
          const rt = (rtRaw || '').toString().trim().toLowerCase();

          const isAudited = (rt === '2') || (rt === 'audited');


          //const nav = this.navigation;
          //const level1 = Array.isArray(nav) ? nav[1] : undefined;
          //const childrenLevel1 = level1 && Array.isArray(level1.children) ? level1.children : undefined;
          //const accountsGroup = Array.isArray(childrenLevel1) ? childrenLevel1[0] : undefined;
          //const accounts = accountsGroup && Array.isArray(accountsGroup.children) ? accountsGroup.children : undefined;

          //if (Array.isArray(accounts)) {
            if (!isAudited) {
              this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "auditorsreport")

              //const incomeIdx = accounts.findIndex(x => x?.id === 'thirdpartyagents');
              //const alreadyHasAuditors = accounts.some(x => x?.id === 'auditorsreport');
              //if (incomeIdx >= 0 && !alreadyHasAuditors) {
              //  accounts.splice(incomeIdx + 1, 0, {
              //    id: 'auditorsreport',
              //    title: "Auditor's Report",
              //    type: 'item',
              //    url: '/auditorsreport'
              //  });
              //}
            //} else {

            //  const auditorsIdx = accounts.findIndex(x => x?.id === 'auditorsreport');
            //  if (auditorsIdx >= 0) {
            //    accounts.splice(auditorsIdx, 1);
            //  }
            //}
          }

          //For Cash Flow statement
          //if (this.commonservice.AccountTemplateId == 11 || (this.commonservice.AccountTemplateId == 2 && this.commonservice.AccountTypeId == 1)) {
          //  if (Array.isArray(accounts)) {
          //    const incomeIdx = accounts.findIndex(x => x?.id === 'directorsreport');
          //    const alreadyHascashflow = accounts.some(x => x?.id === 'cashflow-statement');
          //    if (incomeIdx >= 0 && !alreadyHascashflow) {
          //      accounts.splice(incomeIdx + 1, 0, {
          //        id: 'cashflow-statement',
          //        title: "Cash Flow Statement",
          //        type: 'item',
          //        url: '/cashflow-statement'
          //      });
          //    }
          //  }
          //}

          //if (this.commonservice.AccountTemplateId == 11) {
          //  debugger
          //  var pagedata = this.commonservice.allPagesdata.filter(x => x.IsDefault == true && x.FormName == "Statement of Changes in Equity")
          //  if (pagedata.length>0) {
          //    if (Array.isArray(accounts)) {
          //      const incomeIdx = accounts.findIndex(x => x?.id === 'cashflowstatement');
          //      const alreadyHascashflow = accounts.some(x => x?.id === 'changesinequity');
          //      if (incomeIdx >= 0 && !alreadyHascashflow) {
          //        accounts.splice(incomeIdx + 1, 0, {
          //          id: 'changesinequity',
          //          title: "Statement of Changes in Equity",
          //          type: 'item',
          //          url: '/changesinequity'
          //        });
          //      }
          //    }
          //  }
          //  else {
          //      accounts.filter(x => x?.id !== 'changesinequity');
          //  }
          //}




          if (this.commonservice.AccountTypeId == 3) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "incomestatement" && x.id != "directorsreport" && x.id != "statementofcomprehensiveincome")
          }
          if (this.commonservice.AccountTemplateId != 11 && this.commonservice.AccountTemplateId != 2) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "cashflowstatement")
          }
          else if ((this.commonservice.AccountTemplateId == 11 || this.commonservice.AccountTemplateId == 2) && this.commonservice.AccountTypeId != 1) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "cashflowstatement")
          }
          if (this.commonservice.AccountTemplateId !=11) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "statementofchangesinequity")
          }
          if ((this.commonservice.AccountTemplateId != 2 && this.commonservice.AccountTemplateId != 3 && this.commonservice.AccountTemplateId != 8 && this.commonservice.AccountTemplateId != 11) || (this.commonservice.AccountTypeId == 3)) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "computation")

          }
          if (this.commonservice.leaglformId == 2) {
            if (this.navigation[1].children[0].children.filter(x => x.id == "directorsreport").length > 0)
              this.navigation[1].children[0].children.filter(x => x.id == "directorsreport")[0].title = 'Members Report'
          }
          else {
            if (this.navigation[1].children[0].children.filter(x => x.id == "directorsreport").length > 0)
              this.navigation[1].children[0].children.filter(x => x.id == "directorsreport")[0].title = 'Directors Report'
          }


          var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
          this.commonservice.getNoteMenuList(this.commonservice.AccountTemplateId, APPeriodId).subscribe(data => {
            this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children = this.dynamicNavData1
            this.commonservice.Sidenodes = data
            this.commonservice.Sidenodes = this.commonservice.Sidenodes.filter(x => x.IsChecked == true)
            this.notes = [];
            this.checkednotes = this.commonservice.Sidenodes.filter(x => x.IsChecked == true);
            for (var j = 0; j < this.checkednotes.length; j++) {
              this.notes.push(...this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children.filter(x => x.id == this.checkednotes[j].NotesDescription.toLowerCase().replaceAll(' ', '')))
            }
            // this.notes.unshift(this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children[0])
            this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children = this.notes
          })
          //this.computation.getComputationsData(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
          this.computationservice.getAllComputationsAccountingPeriods(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
            debugger
            if (data.length > 0) {
              this.commonservice.ComputationAccountingPeriodToDate = data[data.length - 1].ComputationsAPPeriodCoveredTo;
            }
            if (data?.length > 0 && (this.commonservice.AccountTemplateId == 2 || this.commonservice.AccountTemplateId == 3 || this.commonservice.AccountTemplateId == 8 || this.commonservice.AccountTemplateId == 11) && (this.commonservice.AccountTypeId != 3)) {
              //this.navigation[1].children[0].children = this.dynamicNavData
              var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
              if (APPeriodId) {
                var datacompu = this.ComputationForms
                datacompu[0].children = this.ComputationForms[0].children.filter(x => x.id == 'computation')
                this.navigation[2].children = datacompu
                //this.navigation[5].children[0].children[0].children = this.computationReport.filter(x => x.id != 'iXBRL_Computations_Reports')
                //for (let i = 0; i < data.length; i++) {
                //  if (data[i].FormStatus == true) {
                this.navigation[4].children[0].children[0].children = this.computationReport;
                //    return false;
                //  }
                //}
                this.computationReport[1].children = []
                for (let i = 0; i < data.length; i++) {
                  var Date1 = this.datepipe.transform(data[i].ComputationsAPPeriodCoveredFrom, "dd/MM/yyyy")
                  var Date2 = this.datepipe.transform(data[i].ComputationsAPPeriodCoveredTo, "dd/MM/yyyy")
                  this.computationReport[1].children.push({ id: 'iXBRL_Computations_Reports', title: Date1 + " - " + Date2, type: 'item', url: '/Computationreportsperiod' + [i + 1] });
                }
                this.navigation[4].children[0].children[0].children = this.computationReport;
                if (window.location.pathname == '/computations-information' || window.location.pathname == '/adjustments') {
                  this.commonservice.Isnavdata(4)
                }
              } 
              //this.navigation[2].children[0].children.splice(1,2)
            }
            else {
              this.navigation[4].children[0].children[0].children = this.computationReport.filter(x => x.id != 'iXBRL_Computations_Reports')
              this.navigation[2].children = null
            }
          })
          if (this.commonservice.AccountTemplateId == 9 || this.commonservice.AccountTemplateId == 10) {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "officerscompany" && x.id != "thirdpartyagents" && x.id != "directorsreport" && x.id != "approvalstatus" && x.id != "statementofcomprehensiveincome")
          }
          //else if (this.commonservice.AccountTemplateId == 10) {
          //  this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "officerscompany" && x.id != "thirdpartyagents" && x.id != "directorsreport" && x.id != "approvalstatus" && x.id != "statementofcomprehensiveincome")
          //}
          else {
            this.navigation[1].children[0].children = this.navigation[1].children[0].children.filter(x => x.id != "approvalstatement")
          }
        }
        // }
      }
      else if (data == 3) {
        this.notes = [];
        this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children = this.dynamicNavData1;
        this.checkednotes = this.commonservice.Sidenodes.filter(x => x.IsChecked == true);
        for (var j = 0; j < this.checkednotes.length; j++) {
          this.notes.push(...this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children.filter(x => x.id == this.checkednotes[j].NotesDescription.toLowerCase().replaceAll(' ', '')))
        }
        //this.notes.unshift(this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children[0])
        this.navigation[1].children[0].children.filter(x => x.id == 'notes')[0].children = this.notes
      }
      else if (data == 4) {
        //if (this.commonservice.AccountTemplateId == 9 || this.commonservice.AccountTemplateId == 10) {
        //  this.navigation[1].children[0].children = this.dynamicNavData
        //}
        //else {
        //  this.navigation[1].children[0].children = this.dynamicNavData.filter(x => x.id != "approvalstatement")
        //}
        this.navigation[2].children = this.ComputationForms
        this.navigation[2].children[0].children = this.ComputationFormschildren
        this.navigation[4].children[0].children[0].children = this.computationReport
        this.navigation[5].children[0].children[1].children.push(...this.dynamicTooldatacomputation)
      }
      else if (data == 5) {
        this.navigation[1].children[0].children = null;
        this.navigation[2].children = null;
        //this.navigation[5].children[0].children = null;
      }
      else if (data == -1) {
        this.navigation[1].children = this.accountsData
        this.navigation[3] = this.statusData
        this.navigation[4].children = this.reportsData
        //this.navigation[2].children = this.computationsData
        this.navigation[4].children[0].children[0].children = this.reportsData[0].children[0].children.filter((x) => (x.id != "iXBRL_Computations_Reports"))
        this.navigation[1].children[0].children = this.dynamicNavData.filter(x => x.id == 'accounting period')
        this.commonservice.setOpenAccountingPeriod(true)
      }
      else if (data == -2) {
        this.navigation[1].children = this.accountsData
        this.navigation[3] = this.statusData
        this.navigation[4].children = this.reportsData
        if ((this.commonservice.AccountTemplateId == 2 || this.commonservice.AccountTemplateId == 3 || this.commonservice.AccountTemplateId == 8 || this.commonservice.AccountTemplateId == 11) && (this.commonservice.AccountTypeId != 3)) {
          this.navigation[2].children = this.computationsData;
          this.navigation[2].children[0].children = this.navigation[2].children[0].children.filter(x => x.id == 'computation')
          this.computationservice.getAllComputationsAccountingPeriods(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
            if (data?.length > 0) {
              this.computationReport[1].children = []
              for (let i = 0; i < data.length; i++) {
                var Date1 = this.datepipe.transform(data[i].ComputationsAPPeriodCoveredFrom, "dd/MM/yyyy")
                var Date2 = this.datepipe.transform(data[i].ComputationsAPPeriodCoveredTo, "dd/MM/yyyy")
                this.computationReport[1].children.push({ id: 'iXBRL_Computations_Reports', title: Date1 + " - " + Date2, type: 'item', url: '/Computationreportsperiod' + [i + 1] });
              }
            }
          })
          this.navigation[4].children[0].children[0].children = this.computationReport;
        }
        else {
          this.navigation[4].children[0].children[0].children = this.computationReport.filter(x => x.id != 'iXBRL_Computations_Reports')
          this.navigation[2].children = null
        }
        this.navigation[1].children[0].children = this.dynamicNavData.filter(x => x.id == 'accounting period' || x.id == 'pageselection')
        this.commonservice.setOpenAccountingPeriod(true)
      }
      else if (data == 0) {
        this.navigation[1].children = null
        this.navigation[3] = []
        this.navigation[4].children = null
        this.navigation[2].children = null
      }
      //else if (data == 9) {
      //  var id = CryptoJS.AES.decrypt(localStorage.getItem("ComputationAPPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
      //  this.navigation[1].children[0].children = this.dynamicNavData.filter(x => x.id == "computation");
      //}
      else {
        if (localStorage.getItem("APPeriodId"))
          var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
        else id = ""
        if (id != "") {
          this.navigation[5].children[0].children.splice(2, 1)
          if (this.navigation[5].children[0].children.filter(x => x.id == 'user-accounts')?.length == 0) {
            this.navigation[5].children[0].children.push(...userManagement)
          }
          if (this.navigation[5].children[0].children.filter(x => x.id == 'FbiReceipt')?.length == 0) {
            this.navigation[5].children[0].children.push(...FBIrecipts)
          }
          this.computationservice.getcomputationdata(id).subscribe((data: any) => {
            this.checkcomputation = data.isComputation;
            if (this.checkcomputation) {
              this.commonservice.isComputation = true
            }
            else {
              if (this.navigation[5].children[0].children[1].children)
                this.navigation[5].children[0].children[1].children.splice(2, 1)
            }
            //this.navigation[1].children[0].children = null;
            this.commonservice.isComputation = false
            //if (this.checkcomputation == true)
            //  this.navigation[2].children = this.ComputationForms;
            //else {
            //this.navigation[2].children = null
            if (this.navigation[5].children[0].children[1].children)
              this.navigation[5].children[0].children[1].children.splice(2, 1)
            //this.navigation[5].children[0].children[0].children = this.computationReport.filter(x => x.id != 'iXBRL_Computations_Reports')

            //this.navigation[5].children[0].children
            //}
          })
        }
        else {
          //this.navigation = this.navigation.filter(x => x.id != 'status')
          this.navigation[5].children[0].children.splice(2, 1)
          if (this.navigation[5].children[0].children.filter(x => x.id == 'user-accounts')?.length == 0) {
            this.navigation[5].children[0].children.push(...userManagement)
          }
          if (this.navigation[5].children[0].children.filter(x => x.id == 'FbiReceipt')?.length == 0) {
            this.navigation[5].children[0].children.push(...FBIrecipts)
          }
          this.navigation[1].children[0].children = null;
          this.navigation[2].children = null;

          if (this.navigation[5].children[0].children[1].children)
            this.navigation[5].children[0].children[1].children.splice(2, 1)

          this.commonservice.isComputation = false
        }
      }
      debugger
      if (this.commonservice.AccountTypeId != 1 && this.commonservice.AccountTypeId != null &&
        (this.commonservice.AccountTemplateId != 2 || this.commonservice.AccountTemplateId != 8 || this.commonservice.AccountTemplateId != 4)) {
        debugger
        const navArray = this.navigation[4].children[0].children;
        if (Array.isArray(navArray)) {
          for (let i = 0; i < navArray.length; i++) {
            if (navArray[i].title == "Detailed Profit & Loss Report") {
              navArray.splice(i, 1);
              this.DetailedProfit = false;
            }
          }
        } else {
          console.error("Navigation array is not defined or is not an array");
        }
      } else {
        const navArray = this.navigation[4].children[0].children;
        if (Array.isArray(navArray)) {
          for (let i = 0; i < navArray.length; i++) {
            if (navArray[i].title == "Detailed Profit & Loss Report") {
              this.DetailedProfit = true;
            }
          }
        }
        if (this.DetailedProfit == false) {
          const newItem = {
            id: "iXBRL reports",
            title: "Detailed Profit & Loss Report",
            type: "item",
            url: "/reports/detailed"
          };
          // Insert newItem at index 1
          navArray.splice(1, 0, newItem); // 0 means no items will be removed
          this.navigation[4].children[0].children = navArray;
        }
      }
    })

    this.commonservice.ImportData.subscribe((data) => {
      if (data) {
        this.navigation[5].children[0].children = this.dynamicTooldata
        if (localStorage.getItem("APPeriodId") == "null" || localStorage.getItem("APPeriodId") == undefined)
          this.navigation[5].children[0].children = this.navigation[5].children[0].children.filter(x => x.id != 'Clear Fields' && x.id != 'Import')
      }
      else {
        this.navigation[5].children[0].children = this.navigation[5].children[0].children.filter(x => x.id != 'Import')
        if (localStorage.getItem("APPeriodId") == "null" || localStorage.getItem("APPeriodId") == undefined)
          this.navigation[5].children[0].children = this.navigation[5].children[0].children.filter(x => x.id != 'Clear Fields' && x.id != 'Import')
      }
    })
  }

  ngAfterViewInit() {
    if (ThemeConfig.layout === 'horizontal') {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
  }
  getcomputationdata() {
    debugger
    var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.computationservice.getcomputationdata(id).subscribe((data: any) => {
      this.checkcomputation = data.isComputation;
    })
  }
  // public method
  scrollPlus() {
    debugger
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > this.contentWidth - this.wrapperWidth) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
  }

  scrollMinus() {
    debugger
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';
    (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    debugger
    if (this.windowWidth < 992 && document.querySelector('app-navigation.pcoded-navbar').classList.contains('mob-open')) {
      this.NavCollapsedMob.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement; 
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        if (ThemeConfig.layout === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        if (ThemeConfig.layout === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        if (ThemeConfig.layout === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }
}
